import React from "react";
// import HotProduct from "../../HotProduct";
import "./footer.scss";
// import Banner from "../../Banner";
import Disclaimer from "../../Disclaimer";
import twitterx from "../../../../src/images/icons8-twitterx.svg";
import instagram from "../../../../src/images/icons8-instagram.svg";
import facebook from "../../../../src/images/icons8-facebook.svg";

const Footer = () => {
  return (
    <footer className={`footer`}>
      {/* <div className="comp-wrap">
        <div className="comp-cont">
          <HotProduct />
        </div>
      </div> test*/}

      {/* <Banner>
        <a target="_blank" href="https://shrsl.com/40clu" rel="noreferrer">
          <img
            src="https://static.shareasale.com/image/125505/Untitled-22.png"
            border="0"
            alt="Eve band"
          />
        </a>
      </Banner> */}
      <div className="Socials flex-it flex-align-item-center flex-justify-center">
        <a href="https://x.com/edropssell">
          <img src={twitterx} />
        </a>
        <a href="https://www.instagram.com/dealsandcommerce/">
          <img src={instagram} />
        </a>
        <a href="https://www.facebook.com/DealsAndCommerce">
          <img src={facebook} />
        </a>
      </div>
      <Disclaimer
        content={`Disclaimer: this site contains affiliate links, updated on 3/19/2025 8:39am`}
      />
    </footer>
  );
};

export default Footer;
